import { LinkId } from '../../../common/AnalyticsContext/LinkId';
import { useSearchFilters } from '../../../common/components/SearchHeader/filters/useSearchFilters';
import { FilterPill } from '../FilterPill/FilterPill';
import { useOverlay } from '../overlay/OverlayContext';

export const SpecialOfferFilter = () => {
  const [filters, setFilters] = useSearchFilters();
  const { clear } = useOverlay();

  const handleClick = () => {
    setFilters({
      ...filters,
      specialOffer: !filters.specialOffer,
    });

    clear();
  };

  return (
    <FilterPill
      trackingId={LinkId.FILTER_BY_SPECIAL_OFFER_BUTTON}
      tooltip="Show practices with a special deal or discount."
      onClick={handleClick}
      hasValue={filters.specialOffer}
    >
      Special offer
    </FilterPill>
  );
};
